import {DossierT17, DossierT39} from "./base.model";

export class NetworkInfo {
  ip: DossierT39 = '';
  mac: DossierT17 = '';
  row: number;
}
